module.exports = __webpack_public_path__ + "static/media/cartouche_femme.dae62c1b.PNG";